export const BFCM2022Constants = {
  StartDate: '2022-10-05 00:00:00',
  EndDate: '2022-11-05 23:59:59'
};

export const BFCM2023Constants = {
  StartDate: '2023-10-16T00:00:01+00:00',
  EndDate: '2023-10-31T23:59:59+00:00'
};

export const LuckyDrawConstants = {
  StartDate: '2023-11-11T00:00:01+00:00',
  EndDate: '2023-11-30T23:59:59+00:00'
};

export const BFCM23SurveyConstants = {
  StartDate: '2023-12-08T00:00:01+00:00',
  EndDate: '2023-12-14T23:59:59+00:00'
};

export const Xmas22Constants = {
  startDate: '2022-12-14 00:00:00',
  endDate: '2022-12-23 23:59:59'
};

export const RELEASE_0423_DAY = '2023-04-19';
export const RELEASE_1031_DAY = '2024-10-31';
